/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-10T15:01:42.75
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentHouseOnline,
	getRentHouseOnlineCreateInit,
	getRentHouseOnlineEditInit,
	getRentHouseOnlineView,
	deleteRentHouseOnline,
	startWorkflow
} from '@api/rentmanage/RentHouseOnline';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

import {
listRentHouseOnlineItemInit,
listRentHouseOnlineItemByAuthorizations,
deleteRentHouseOnlineItem
} from '@api/rentmanage/RentHouseOnlineItem';

export default {
	namespaced: true,

	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentHouseOnlineCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseOnlineCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseOnlineEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseOnlineEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		startWorkflow({}, RentHouseOnline) {
			return new Promise((resolve, reject) => {
				startWorkflow(RentHouseOnline)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		saveRentHouseOnline({}, RentHouseOnline) {
			return new Promise((resolve, reject) => {
				saveRentHouseOnline(RentHouseOnline)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseOnlineView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseOnlineView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseOnline({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseOnline({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
